module.exports = __webpack_public_path__ + "static/img/2.fbc3b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/4/2.png
// module id = MKH+
// module chunks = 0